module.exports = __webpack_public_path__ + "img/re_men.cf6897ea.png";